var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useFormikContext } from 'formik';
import React from 'react';
import { Card, CardBody, CardHeader, Form } from 'reactstrap';
import { ODFlexContentsContainer } from '../../../layout';
import { ODEntityEditorFooter } from './ODEntityEditorFooter';
import { ODEntityEditorHeader } from './ODEntityEditorHeader';
export var FormikReactstrapForm = function (props) {
    var children = props.children;
    var handleSubmit = useFormikContext().handleSubmit;
    return (
    // @ts-ignore
    React.createElement(Form, __assign({ onSubmit: handleSubmit }, props), children));
};
export function ODEntityEditorReactstrap(props) {
    var title = props.title, children = props.children, saveButtonName = props.saveButtonName, deleteButtonName = props.deleteButtonName, deleteConfirmOptions = props.deleteConfirmOptions, _a = props.noCardWrap, noCardWrap = _a === void 0 ? false : _a, _b = props.footerProps, footerProps = _b === void 0 ? {} : _b;
    if (noCardWrap) {
        return (React.createElement(ODFlexContentsContainer, null,
            React.createElement(FormikReactstrapForm, { noValidate: true, name: "simpleForm" },
                children,
                React.createElement(ODEntityEditorFooter, __assign({ saveButtonName: saveButtonName, deleteButtonName: deleteButtonName, deleteConfirmOptions: deleteConfirmOptions }, footerProps)))));
    }
    return (React.createElement(ODFlexContentsContainer, null,
        React.createElement(Card, { style: { padding: 0, margin: 0 } },
            React.createElement(CardHeader, null,
                React.createElement(ODEntityEditorHeader, { title: title, populateDevData: function () { return ({}); } })),
            React.createElement(CardBody, null,
                React.createElement(FormikReactstrapForm, { noValidate: true, name: "simpleForm" },
                    children,
                    React.createElement(ODEntityEditorFooter, __assign({ saveButtonName: saveButtonName, deleteButtonName: deleteButtonName, deleteConfirmOptions: deleteConfirmOptions }, footerProps)))))));
}
//# sourceMappingURL=ODEntityEditorReactstrap.js.map